// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M2.5 3.5H13.5M2.5 8H13.5M2.5 12.5H13.5'];
